import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';

@Injectable()
export class RepLedgerDemandsService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(http, configService, eventsEmitterService, router, logger, 'RepLedgerDemandsService');
  }

  // initData(params:any): Observable<any>{
  //     let serviceUrl = this.baseUrl + this.serviceName+'/init?clientVAT='+this.getFromStorageAsJSON('home_info', false).vat + "&" +this.urlParamsToString(params);

  //     return this.request(serviceUrl).pipe(map(super.extractData),catchError(super.handleError));
  // };
}
